import { useQuery } from '@tanstack/react-query';
import {
  fetchPreferenceOptions,
  getPreferenceOptionsQueryKey,
} from './fetchPreferenceOptions';

const timeLimit = 5 * 60 * 1000;

export function useGetPreferenceOptions(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: getPreferenceOptionsQueryKey(),
    queryFn: fetchPreferenceOptions,
    retry: false,
    gcTime: timeLimit,
    staleTime: timeLimit,
    enabled: options?.enabled !== false,
  });
}
